export default {
	props: {
		isEdit: {
			type: Boolean,
			default: false
		},
		value: {
			type: [Object, Array],
			required: true
		}
	},
	watch: {
		isEdit: {
			immediate: true,
			handler(val) {
				this.$nextTick(() => {
					if (val && this.$refs.defaultFocusElement) {
						this.$refs.defaultFocusElement.focus();
					}
				});
				
			}
		}
	},
	methods: {
		$_getFormValue(key) {
			return this.value[key] != null && this.value[key] !== '' ? this.value[key] : '-';
		},
		$_validateForm() {
			if (!this.$v) return true;

			this.$v.$touch();
			return !this.$v.$invalid;
		}
	}
};
